export enum TRADE_TERM_TYPE_ENUM {
  Together = 1,
  Offline = 2,
  Online = 3,
}
